import styled from 'styled-components';

type IconSizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const getSizeStyles = (size: IconSizes) => {
  const sizeVariants = {
    xs: {
      padding: '4px',
    },
    sm: {
      padding: '6px',
    },
    md: {
      padding: '8px',
    },
    lg: {
      padding: '10px',
    },
    xl: {
      padding: '10px',
    },
  };
  return sizeVariants[size];
};

const getSVGSizeStyles = (size: IconSizes) => {
  const sizeVariants = {
    xs: {
      height: '18px',
      width: '18px',
    },
    sm: {
      height: '20px',
      width: '20px',
    },
    md: {
      height: '24px',
      width: '24px',
    },
    lg: {
      height: '28px',
      width: '28px',
    },
    xl: {
      height: '30px',
      width: '30px',
    },
  };
  return sizeVariants[size];
};

const getIconButtonBorderStyle = (showBorder?: boolean, disabled?: boolean) => {
  if (showBorder && disabled) {
    return '1px solid rgba(210, 210, 210, 1)';
  }
  if (showBorder && !disabled) {
    return '1px solid rgba(136, 136, 136, 1)';
  }
  return 'none';
};

const IconButton = styled.div<{
  disabled?: boolean;
  size?: IconSizes;
  width?: string;
  showBorder?: boolean;
}>`
  border: ${({ showBorder, disabled }) =>
    getIconButtonBorderStyle(showBorder, disabled)};
  border-radius: ${({ theme }) => theme.borderRadius};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${({ size }) => (size ? getSizeStyles(size) : getSizeStyles('sm'))}
  background: transparent;
  svg {
    ${({ size }) => (size ? getSVGSizeStyles(size) : getSVGSizeStyles('sm'))}
  }
  &:hover {
    background: ${({ theme }) => 'rgba(0, 0, 0, 0.04)'};
  }
  width: ${({ width }) => (width ? width : 'auto')};
};`;

export default IconButton;
